import { withFeatureFlags } from '@/flags.server';
import { NextSeo } from 'next-seo';
import { ROOT_URL_PRODUCTION } from 'next-seo.config';

import { isRwaRestrictedInCountry } from '@/lib/geo/restrictedIssuers';

import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { DiscoverySection } from '@/components/HomepageV3/DiscoverySection';

import { useGeoCheck } from '@/hooks/useGeoCheck';

import { getCachedWalletAddresses } from '@/utils/cachedWalletAddresses';
import { routes } from '@/utils/routes';

export default function TokensPage() {
  const { data: geo } = useGeoCheck();
  const showStocksAvailabilityBanner = isRwaRestrictedInCountry(geo?.country ?? 'unknown');

  return (
    <div className="overflow-hidden h-fit min-h-screen">
      <NextSeo
        title="Discover Tokens | Prices, Charts & Trends | Matcha"
        description="Discover tokens on Matcha with live prices, charts, and market trends across supported networks."
        canonical={`${ROOT_URL_PRODUCTION}${routes.TOKENS}`}
      />
      <Header isHomepage />
      <div className="h-[114px] [body[data-show-banner='true']_&]:h-[139px] tablet:h-[165px] tablet:[body[data-show-banner='true']_&]:h-[190px]" />
      <DiscoverySection
        showStocksAvailabilityBanner={showStocksAvailabilityBanner}
        includePopular={false}
      />
      <div className="h-14" />
      <hr className="border-token-gray-300" />
      <Footer isHomepage />
    </div>
  );
}

export const getServerSideProps = withFeatureFlags(async (context) => ({
  props: { cachedWalletAddresses: getCachedWalletAddresses(context) },
}));
